import React , { useState} from 'react';
import './styles.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import api from '../../services/api';
import '../../global.css';

function Login(){
    
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');

    async function HandleSubmit(event){
        event.preventDefault();

        const data = {
            user,
            password
        };

        try{
            const response = await api.post('login', data);
            alert('Login realizado com sucesso');
        }catch (err){
            alert(err);
        };
    }

    return(
        <>
            <Header/>

            <div id="content">
                <form onSubmit={HandleSubmit}>
                    <h1>Faça seu Login</h1>

                    <input
                        type='text'
                        placeholder = 'Usuário'
                        className = "form"
                        value={user}
                        onChange={e => setUser(e.target.value)}
                    />
                    <input 
                        type='text'
                        placeholder='Senha'
                        className = "form"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                    <button className='botao' type='submit'>Entrar</button>
                </form>
            </div>

            <Footer/>
        </>
    );
}

export default Login;